<app-vaccination-document-view *ngIf="isReady && !isEdit" [document]="document"></app-vaccination-document-view>
<app-vaccination-document-edit *ngIf="isReady && isEdit" [document]="document" [defaultTypeCode]="defaultTypeCode"></app-vaccination-document-edit>
